import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Type } from 'src/app/shared/models/type.model';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { TypesService } from '../types.service';

@Component({
  selector: 'app-type-list',
  templateUrl: './type-list.component.html',
  styleUrls: ['./type-list.component.css']
})
export class TypeListComponent implements OnInit {
  type = new Type();
  tableColumns = ['name'];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editType',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'deleteType',
      class: 'btn',
      iconClasses: 'fa fa-trash'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'name',
      fieldDisplayName: 'Title ',
      fieldType: 'text'
    },
    // {
    //   fieldName: 'createdAt',
    //   fieldDisplayName: 'created At ',
    //   fieldType: 'daterange'
    // },
  ];
  private Data = [] as Array<TableViewItem>;
  currentFilterObject = {} as FilterModel;
  constructor(
    private typeApi: TypesService,
    private notifier: SnotifyService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  get data(): Array<TableViewItem> {
    return this.Data
    // .filter(row => {
    //   if (
    //     this.currentFilterObject.createdAt &&
    //     this.currentFilterObject.createdAt.startDate &&
    //     this.currentFilterObject.createdAt.endDate
    //   ) {
    //     return moment(row.createdAt).isBetween(
    //       // @ts-ignore
    //       this.currentFilterObject.expiresAt.startDate._i,
    //       // @ts-ignore
    //       this.currentFilterObject.expiresAt.endDate._i
    //     );
    //   } else {
    //     return true;
    //   }
    // })
    .filter(row => {
      if (this.currentFilterObject.name) {
        return row.name.includes(this.currentFilterObject.name);
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  ngOnInit() {
    this.fetchAllTypes();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllTypes() {
    this.typeApi.getTypes().subscribe(response => {
      this.data = response.data.tagGroups.map(r => {
        return {
          id: r.id,
          name: r.name,
          // createdAt: r.createdAt,
          // updatedAt: r.updatedAt
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editType':
        this.type = event.on;
        this.router.navigateByUrl('/filters/type/edit/' + this.type.id);
        break;
      case 'deleteType':
        this.type = event.on;
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllTypes();
    }
  }
}

interface TableViewItem {
  name?: string;
  // createdAt?: string;
  // updatedAt?: string;
}

interface FilterModel {
  name?: string;
  // createdAt?: DateRangeModel;
}

interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
